var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full flex flex-col overflow-y-auto"},[_c('PoliciesHeader',{staticClass:"sticky top-0 z-50"}),_c('router-view'),_c('ModalPolicyCreateEdit'),_c('ModalDuplicatePolicy'),_c('ModalDeletePolicy')],1)}
var staticRenderFns = []

export { render, staticRenderFns }